import { Box, Divider, Tooltip, Typography, styled } from '@mui/material';
import type { IAppDetailsAppData } from '../common-types';
import type { ImageProps } from 'next/image';
import { useAppDetails } from '../AppDetailsState';

const Container = styled('div')(({ theme }) => ({
  padding: `${theme.spacing(3)} 0`,
}));

export type SchemeStripProps = {
  FlexibleImageComponent: React.ComponentType<ImageProps>;
  translatedText: {
    schemesHeading: string;
  };
  configuration?: {
    title?: string;
  };
};

export const SchemeStrip = ({
  FlexibleImageComponent,
  translatedText,
  configuration,
  ...props
}: SchemeStripProps) => {
  const { schemes } = useAppDetails().app as IAppDetailsAppData;

  if (!schemes || schemes.length === 0) {
    return <></>;
  }

  return (
    <Container {...props}>
      <Box sx={{ display: 'grid', gap: (theme) => theme.spacing(2) }}>
        <Typography component="h2" variant="h6">
          {configuration?.title ?? translatedText?.schemesHeading}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            gap: (theme) => theme.spacing(2.5),
            flexWrap: 'wrap',
          }}
        >
          {schemes.map((scheme, index) => (
            <Box
              key={scheme.id}
              sx={{
                display: 'inline-block',
                marginRight: index < schemes.length - 1 ? 2 : 0,
              }}
            >
              {index > 0 && (
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{ marginRight: 2 }}
                />
              )}
              <Tooltip title={scheme.type || ''} arrow>
                <FlexibleImageComponent
                  key={scheme.id}
                  src={scheme.imageUrl || ''}
                  alt={scheme.type || 'Scheme Image'}
                  width={128}
                  height={64}
                  style={{
                    objectFit: 'contain',
                    fontSize: '.8rem',
                    wordBreak: 'break-all',
                  }}
                />
              </Tooltip>
            </Box>
          ))}
        </Box>
      </Box>
    </Container>
  );
};
